import { render, staticRenderFns } from "./detail_contactInfo.vue?vue&type=template&id=6140aab6&scoped=true&"
import script from "./detail_contactInfo.vue?vue&type=script&lang=js&"
export * from "./detail_contactInfo.vue?vue&type=script&lang=js&"
import style0 from "./detail_contactInfo.vue?vue&type=style&index=0&id=6140aab6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6140aab6",
  null
  
)

export default component.exports